import React, { useEffect, useState } from 'react';
import PageBanner from "../PageBanner";
import Layout from "../../layout/Layout";
import { Link } from 'react-router-dom';
import product1 from "../../assets/images/widgets/product1.jpg";
import product2 from "../../assets/images/widgets/product2.jpg";
import product3 from "../../assets/images/widgets/product3.jpg";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('grid'); // State to manage view mode
  const [sortOption, setSortOption] = useState('default');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('http://api.sourceofsurgical.com/api/product/getAllProducts');
        const data = await response.json();
        console.log("Response product data:", data);
        setProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const sortProducts = (option) => {
    setSortOption(option);
    let sortedProducts = [...products];

    if (option === 'New') {
      sortedProducts.sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
    } else if (option === 'old') {
      sortedProducts.sort((a, b) => new Date(a.createAt) - new Date(b.createAt));
    } else if (option === 'high-to-low') {
      sortedProducts.sort((a, b) => b.productPrice - a.productPrice);
    } else if (option === 'low-to-high') {
      sortedProducts.sort((a, b) => a.productPrice - b.productPrice);
    }

    setProducts(sortedProducts);
  };

  if (loading) {
    return <div>Loading...</div>; // Placeholder while loading
  }

  return (
    <Layout>
      <PageBanner pageName={"Shop"} />
      <section className="shop-page-area py-130 rpy-100">
        <div className="container">
          <div className="shop-shorter rel z-3 mb-45 wow fadeInUp delay-0-2s">
            <a className="filter-part" href="#">
              <i className="fal fa-bars" />
              <span>Show Filters</span>
            </a>
            <div className="sort-text">Showing {products.length} results</div>
            <div className="products-dropdown">
              <select value={sortOption} onChange={(e) => sortProducts(e.target.value)}>
                <option value="default">Default Sorting</option>
                <option value="New">Sort by Newness</option>
                <option value="old">Sort by Oldest</option>
                <option value="high-to-low">High To Low</option>
                <option value="low-to-high">Low To High</option>
              </select>
            </div>
            <ul className="grid-list">
              <li>
                <a href="#" onClick={() => setViewMode('grid')}>
                  <i className={`fal fa-border-all ${viewMode === 'grid' ? 'active' : ''}`} />
                </a>
              </li>
              <li>
                <a href="#" onClick={() => setViewMode('list')}>
                  <i className={`far fa-list ${viewMode === 'list' ? 'active' : ''}`} />
                </a>
              </li>
            </ul>
          </div>
          <div className="row gap-60">
            <div className="col-lg-3">
              <div className="shop-sidebar rmb-75">
                <div className="widget widget-search wow fadeInUp delay-0-2s">
                  <form
                    onSubmit={(e) => e.preventDefault()}
                    action="#"
                    className="default-search-form"
                  >
                    <input type="text" placeholder="Search Keywords" required />
                    <button
                      type="submit"
                      className="searchbutton far fa-search"
                    />
                  </form>
                </div>
                <div className="widget widget-category wow fadeInUp delay-0-4s">
                  <h5 className="widget-title">Category</h5>
                  <ul>
                    <li>
                      <Link legacyBehavior href="shop">
                        Book Cover
                      </Link>{" "}
                      <span>(8)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="shop">
                        Logo Branding
                      </Link>{" "}
                      <span>(5)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="shop">
                        T-Shart Design
                      </Link>{" "}
                      <span>(3)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="shop">
                        Business Cards
                      </Link>{" "}
                      <span>(9)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="shop">
                        Web Design
                      </Link>{" "}
                      <span>(4)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="shop">
                        Landing Pages
                      </Link>{" "}
                      <span>(6)</span>
                    </li>
                  </ul>
                </div>
                <div className="widget widget-products wow fadeInUp delay-0-2s">
                  <h5 className="widget-title">Best Seller</h5>
                  <ul>
                    <li>
                      <div className="image">
                        <img
                          src={product1}
                          alt="Product"
                        />
                      </div>
                      <div className="content">
                        <div className="ratting">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                        <h5>
                          <Link legacyBehavior href="product-details">
                            Logo Design
                          </Link>
                        </h5>
                        <span className="price">$29.95</span>
                      </div>
                    </li>
                    <li>
                      <div className="image">
                        <img
                          src={product2}
                          alt="Product"
                        />
                      </div>
                      <div className="content">
                        <div className="ratting">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                        <h5>
                          <Link legacyBehavior href="product-details">
                            Mobile Apps
                          </Link>
                        </h5>
                        <span className="price">$29.95</span>
                      </div>
                    </li>
                    <li>
                      <div className="image">
                        <img
                          src={product3}
                          alt="Product"
                        />
                      </div>
                      <div className="content">
                        <div className="ratting">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                        <h5>
                          <Link legacyBehavior href="product-details">
                            Business Card
                          </Link>
                        </h5>
                        <span className="price">$29.95</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="widget widget-tag-cloud wow fadeInUp delay-0-2s">
                  <h5 className="widget-title">Popular Tags</h5>
                  <div className="tag-coulds">
                    <Link legacyBehavior href="blog">
                      Printing
                    </Link>
                    <Link legacyBehavior href="blog">
                      Design
                    </Link>
                    <Link legacyBehavior href="blog">
                      Ofset
                    </Link>
                    <Link legacyBehavior href="blog">
                      Branding
                    </Link>
                    <Link legacyBehavior href="blog">
                      3D Printing
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-lg-${viewMode === 'list' ? 9 : 9}`}>
              <div className={`row ${viewMode === 'list' ? 'list-view' : ''}`}>
                {products.map(product => (
                  <div className={`col-lg-${viewMode === 'list' ? 12 : 4} col-sm-6`} key={product.id}>
                    <div className={`product-item wow fadeInUp delay-0-2s ${viewMode === 'list' ? 'list-view' : ''}`}>
                      <div className="image">
                        <img
                          className={`product-image ${viewMode === 'list' ? 'list-image' : 'grid-image'}`}
                          src={product.productImages || 'path/to/placeholder/image.jpg'}
                          alt={product.productTitle}
                        />
                      </div>
                      <div className="content">
                        <div className="title-price">
                          <h5>
                            <Link to={`/product-details/${product.productID}`}>
                              {product.productTitle}
                            </Link>
                          </h5>
                          <div className="price">${product.productPrice}</div>
                        </div>
                      </div>
                      <div className="social-style-two">
                        <a href="#">
                          <i className="far fa-shopping-cart" />
                        </a>
                        <a href="#">
                          <i className="far fa-heart" />
                        </a>
                        <a href="#">
                          <i className="far fa-eye" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <ul className="pagination flex-wrap wow fadeInUp delay-0-2s">
                <li className="page-item disabled">
                  <span className="page-link">
                    <i className="fas fa-chevron-left" />
                  </span>
                </li>
                <li className="page-item active">
                  <span className="page-link">
                    01
                    <span className="sr-only">(current)</span>
                  </span>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    02
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    03
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    04
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    <i className="fas fa-chevron-right" />
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Shop;
